import React, { useState } from 'react';

export default function CancelSurveyModal({ onConfirm, onClose }) {
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    setSubmitting(true);
    await onConfirm(reason);
  };

  const handleSkip = async () => {
    setSubmitting(true);
    await onConfirm('');
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 440 }}>
        <p style={{ lineHeight: 1.6, marginBottom: 16 }}>
          We're always trying to make Train Daily better. Can you please take 10-60 seconds below to let us know why you are cancelling? Thank you so much!
        </p>
        <textarea
          value={reason}
          onChange={e => setReason(e.target.value)}
          placeholder="Your feedback..."
          rows={4}
          style={{
            width: '100%',
            padding: 10,
            borderRadius: 8,
            border: '1px solid var(--card-border)',
            background: 'var(--input-bg, #1a1a2e)',
            color: 'var(--text-color, #fff)',
            fontSize: '0.95rem',
            resize: 'vertical',
            boxSizing: 'border-box',
          }}
          disabled={submitting}
        />
        <div className="modal-actions" style={{ flexDirection: 'column', gap: 8 }}>
          <button
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={submitting}
            style={{ width: '100%' }}
          >
            {submitting ? 'Cancelling...' : 'Submit & Cancel Subscription'}
          </button>
          <button
            onClick={handleSkip}
            disabled={submitting}
            style={{
              background: 'none',
              border: 'none',
              color: 'var(--text-muted, #999)',
              cursor: 'pointer',
              fontSize: '0.85rem',
              padding: 4,
            }}
          >
            Skip & cancel subscription
          </button>
        </div>
      </div>
    </div>
  );
}
